import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import style from './Header.module.scss';
import tokenService from "../../tools/tokenService";
import API from "../../tools/API"


const Header = () => {
    const navigate = useNavigate();

    const logoutUser = () => {
        API.logOut();
        localStorage.clear();
        navigate('/login');
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (tokenService.checkTokenDate() === false) {
                navigate('/login');
            } else {
                return
            }
        }, 1500);
        return () => clearInterval(interval);
    }, []);

    return (
        <header className={style.header}>
            <div className={style.header__lowerRow}>
                <nav className={style.header__navigation}>
                    <ul className={style.header__navigationList}>
                        <li className={style.header__singleNavigation}>
                            <Link to="/">
                                <span className="material-icons">
                                    home
                                </span>
                                Strona główna
                            </Link>
                        </li>
                        <li className={style.header__singleNavigation}>
                            <Link to="/glosowania">
                                <span className="material-icons">
                                    looks_one
                                </span>
                                Aktywne głosowania
                            </Link>
                        </li>
                        <li className={style.header__singleNavigation}>
                            <Link to="/wyniki">
                                <span className="material-icons">
                                    trending_up
                                </span>
                                Wyniki głosowań
                            </Link>
                        </li>
                        <li className={style.header__singleNavigation}>
                            <Link to="/ustawienia">
                                <span className="material-icons">
                                    settings
                                </span>
                                Ustawienia
                            </Link>
                        </li>
                        <li className={style.header__singleNavigation}>
                            <Link to="/tagi">
                                <span className="material-icons">
                                    tag
                                </span>
                                Tagi
                            </Link>
                        </li>
                    </ul>
                </nav>
                {
                    localStorage.getItem('user') === null ? null :
                        <div
                            className={style.logoutBox}
                            onClick={() => logoutUser()}
                        >
                            <div className={style.header__userIcon}>
                                <div className={style.userLogo}></div>
                            </div>
                            <div className={style.logoutText}><span>WYLOGUJ</span></div>
                        </div>
                }
            </div>
        </header>
    )
}

export default Header;